let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jtXji")).then(() => parcelRequire('bIkmc'));